module.exports = __webpack_public_path__ + "img/page.623aa8e7.png";